export const CONFIGURE_PENDING = 'appConfig/CONFIGURE_PENDING';
export const CONFIGURE_SUCCESS = 'appConfig/CONFIGURE_SUCCESS';
export const CONFIGURE_ERROR = 'appConfig/CONFIGURE_ERROR';
